import * as Yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    passwordComplexity(message: string): StringSchema;
  }
}

// 비밀번호 검증을 위한 Yup 확장 메소드
Yup.addMethod(Yup.string, 'passwordComplexity', function (message: string) {
  return this.test('passwordComplexity', message, function (value) {
    const { path, createError } = this; // Yup의 테스트 메소드 내부에서 사용되는 헬퍼 함수
    const inputValue = value || ''; // 입력된 값이 없으면 빈 문자열로 설정

    /** 비밀번호 조건 검사*/
    // 조건에 따른 길이 검증
    if (inputValue.length < 8) {
      return createError({ path, message: '최소 8자 이상 입력해주세요.' });
    }

    if (inputValue.length > 20) {
      return createError({ path, message: '최대 20자까지 입력 가능합니다.' });
    }

    // 공백 포함 여부 검사
    if (/\s/.test(inputValue)) {
      return createError({ path, message: '공백을 포함할 수 없습니다.' });
    }

    // 같은 문자/숫자 반복 여부 검사
    if (/(\w)\1{3,}/.test(inputValue)) {
      return createError({ path, message: '같은 문자/숫자를 4번 이상 사용할 수 없습니다.' });
    }

    // 연속된 숫자 여부 검사
    if (
      /(0123|1234|2345|3456|4567|5678|6789|7890|0987|9876|8765|7654|6543|5432|4321|3210)/.test(
        inputValue,
      )
    ) {
      return createError({ path, message: '4번 이상 연속된 숫자를 사용할 수 없습니다.' });
    }

    // 특수문자 포함 여부 검사
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(inputValue)) {
      return createError({ path, message: '특수문자를 포함해야 합니다.' });
    }

    // ID 포함 여부 검사
    const loginId = this.parent?.loginId;
    if (loginId && inputValue.includes(loginId) && inputValue.trim() !== loginId.trim()) {
      return createError({ path, message: 'ID를 포함할 수 없습니다.' });
    }
    return true;
  });
});

// 비밀번호 유효성 검사
const pwdValidation = Yup.string()
  .nullable()
  .trim()
  .passwordComplexity('영문, 숫자, 특수문자를 혼합한 8~20 자리를 입력해주세요.');

// 비밀번호 확인 유효성 검사
const confirmPwdValidation = Yup.string()
  .oneOf([Yup.ref('pwd')], '비밀번호가 서로 다릅니다.')
  .required('비밀번호 확인을 입력하세요');

export { confirmPwdValidation, pwdValidation };
